// MultiTabEdu.jsx

import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
// import "./SingleTab.css";
import "../../UI_Design/SingleTab/./SingleTab.css";
import DigiTab from "./digiTab";
import GetMasterData from "../../Helper/masterData";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getDigiLockerFields,
  getDigiMoqList,
  verifyDigiLockerDocuments,
} from "../../Actions/DigiLockerActions";
import UploadDIgiDocs from "./UploadDIgiDocs";
import { deleteSaveEducation, saveEducation, addEducation} from "../../Actions/educationActions";
import { getData } from "../../Actions/landingAction";
import { toast } from "react-toastify";
import DigilockerPopup from "./digilockerPopup";
import Loader from "../Common/loader";

import "../DiyIcvDigilockerSingleEducation/style.css";

const MultiTabEdu = ({ tabs, checkName, educationData, setSelectedCaseCheckId,reference, reSetData, reRenderAgain2 }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState(0);
  const [add,setAdd] = useState(0);
  const [caseCheckId, setCaseCheckId] = useState("");
  const [documentVisibility, setDocumentVisibility] = useState("");
  const [cisSlug, setCisSlug] = useState("");
  const [moqOptions, setMoqOptions] = useState([]);
  const [tabsFieldData, setTabFieldData] = useState({});
  const [newRecord, setNewRecord] = useState({});
  const [showDigiPopup, setShowDigiPopup] = useState(false);
  const [isDisabled, setIsDisabled] = useState(true);
  const [allFields, setAllFields] = useState([]);
  const [allFieldsResponse, setAllFieldsResponse] = useState();
  const [newValidationRecord, setNewValidationRecord] = useState({});
  const [allResponseError, setAllResponseError] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [univType, setUnivType] = useState({});
  const [isOther, setIsOther] = useState(0);
  const [education, setEducation] = useState([]);
  const [showAllFields, setShowAllFields] = useState(false);
  const [addMore, setAddMore] = useState(false);
  const [formVal, setFormVal] = useState({});
  const [formError, setFormError] = useState({});
  const [checked, setChecked] = React.useState(false);
  const [digiResult, setDigiResult] = useState(false);
  const [allDisabled, setAllDisabled] = useState(false);
  const [otherInstituteObj,setOtherInstituteObj]=useState({});
  const initialEffectFlag = useRef(false);

  useEffect(() => {
    if (showDigiPopup) {
      // Disable scrolling on the body when the modal is open
      document.body.classList.add('modal-open');
    } else {
      // Enable scrolling on the body when the modal is closed
      document.body.classList.remove('modal-open');
    }
  }, [showDigiPopup]);

  useEffect(() => {
    if (educationData !== undefined && educationData !== undefined) {
      setEducation(educationData);
      let id = educationData?.initial_case_id
      let ts_id = educationData?.transation_id
      if(id){
        localStorage.setItem('digiCaseId' , id);
      }
      if(ts_id){
        localStorage.setItem('digiTransId' , ts_id);
      }
    }
  }, [educationData]);

  useEffect(() => {
    if (tabs && tabs.length > 0) {
      let url = window.location.pathname.split('/')
      if(url[url.length - 1] == 'uploadDigi'){
        setActiveTab(tabs.length + 1);
        
      }
      // else{
        console.log("tabssss....",tabs)
        // let allChecksCompleted = -1;
        const fieldsData = tabs.map((data, index) => {
          if(data.check_status == 1){
            
          }
          return data?.fields;
        });
        setTabFieldData(fieldsData);
        setCaseCheckId(fieldsData[0]?.caseCheckId);
        setSelectedCaseCheckId(fieldsData[0]?.caseCheckId);
        setDocumentVisibility(fieldsData[0]?.document_visibility);
        setCisSlug("verificationName_" + fieldsData[0]?.caseCheckId);
        // const documentVisibility = value.document_visibility;
        // setActiveTab(1);
      // }
    }
  }, [tabs]);

  // getting values to show in dropdowns
  const {
    degreeOptions,
    veridficationCourseNameOptions,
    qualificationOptions,
    modeOfQualificationOptions,
    digiLockerUniversityList,
  } = GetMasterData();

  useEffect(() => {
    localStorage.setItem("reference", reference);
    const showDigi = localStorage?.getItem('digiResponse');
    // showDigi==1?setDigiResult(true):setDigiResult(false)
    // if(showDigi == 1){
    //   setActiveTab(tabs.length + 1);
    //   // saveTab
    //   // tabs
    // }else{
    // }
    setActiveTab(1);
    let flag = localStorage.getItem("disableEditDigi");
    flag == 'true' ? setAllDisabled(true) : setAllDisabled(false);
  }, []);

  const storeEducationSave = useSelector((state) => state.educationSave);
  const {
    educationSaveData,
    loading: saveLoading,
    error: saveError, 
  } = storeEducationSave;
  console.log(educationSaveData); 
  useEffect(() => {
    if (typeof saveLoading !== "undefined" && saveLoading !== null) {
      if (saveLoading === true) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
        //  reRenderAgain();
      }
    }
  }, [saveLoading]);

  //redirecting after saving
  // useEffect(()=>{
  //   if(digiResult==true){
  //     navigate(`/case-initiation/profile-preview/${reference}`);
  //   }
  // },[educationSaveData, storeEducationSave])
  useEffect(() => {
    if (
      typeof educationSaveData?.reference_number !== "undefined" &&
      educationSaveData?.reference_number !== null &&
      digiResult==false
    ) {
      dispatch(getData());
      reSetData();
      reRenderAgain2();

       setIsLoading(true);

      const group = educationSaveData.group
        ? educationSaveData.group.group_id
        : "";
      const hasNextCheck = educationSaveData.nextCheck != "" ? true : false;
      const reference = educationSaveData.reference_number;
      if(educationSaveData.isDigilocker){
        setShowDigiPopup(true);
        setIsLoading(false);
        window.scrollTo(0, 0);
      }else 
      // if (!hasNextCheck) {
      //   if (group == "profile_preview") {
      //     navigate(`/case-initiation/profile-preview/${reference}`);
      //     dispatch(deleteSaveEducation());
      //   } else if (typeof group != "undefined" && group != "") {
      //     navigate(`/case-initiation/check-detail/${reference}/${group}`);
      //     dispatch(deleteSaveEducation());
      //   }
      // } else
       {
        // navigate(
        //   `/case-initiation/check-detail/${reference}/3/${educationSaveData.nextCheck}`
        // );
        // if(add){
         if(educationSaveData?.is_add_edu){ 
          setActiveTab(Object.keys(education.checksDetails).length+1)}
        else{
        setTabAfterSave(educationSaveData.nextCheck,educationSaveData?.is_education_completed)}
        dispatch(deleteSaveEducation());
        setIsLoading(false);
        window.scrollTo(0, 0);
      }
    }
  }, [educationSaveData, storeEducationSave]);

  const setTabAfterSave = (checkID, completedFlag) => {
    let idx = -1;
    let allChecksCompleted = true;
    {tabs.map((tab, index) => {
      if(tab?.case_check_id == checkID){
        idx = index
        // return idx;
      }
      if(tab?.check_status == 1){
        allChecksCompleted = false;
      }
    })
    if(idx == -1){
      // allChecksCompleted ? setActiveTab(tabs.length + 1) : setActiveTab(1);
      if(completedFlag){
        setActiveTab(tabs.length + 1);
        navigate('./uploadDigi');
      }else{
        setActiveTab(1);
      }
      // setActiveTab(1)
      // return 0;
    }else{
//       return idx;
      setActiveTab(idx + 1);
    }

  }
  }

  useEffect(() => {
    if(!initialEffectFlag.current && education && education?.checkdetailsindex){
      Object.values(education?.checkdetailsindex).map((data, idx) => {
        setOtherInstituteObj((prev) => ({
          ...prev,
          [idx] : {value:'',isError:false,isVisible:false}
        }))
      })
      initialEffectFlag.current = true;
    }
  },[education])

  useEffect(() => {
    if(typeof education.checksDetails !== "undefined" &&
    education.checksDetails !== null){

        let allFieldsFlag = false;
        let allCompleted = true;

        Object.values(education?.checksDetails).map((data, index) => {
          if(data.check_status == 1){
            allCompleted = false;
          }

          // if(education.checksDetails[index]){
          //   // if(education.checksDetails[index])
          //   setOtherInstituteObj((prev) => ({
          //     ...prev,
          //     [index] : {value:'',isError:false,isVisible:false}
          //   }))
          // }

          // if(education.checksDetails[index]?.edu_org_id){
          //   setUnivType((prev) => ({
          //         ...prev,
          //         [index] : ''
          //       }))
          // }else{
          //   setUnivType((prev) => ({
          //     ...prev,
          //     [index] : 'Other'
          //   }))
          // }

          Object.entries(education.checksDetails[index].fields).map(
            ([key, value]) => {
              // if(initialDataKey == 1){
                // setInitialDataKey(0);
                // if (value.id == 466) {
                //     // setIsOther(value.field_value.toString());
                //     if(value.field_value == 'Other' || value.field_value == 1){
                //         // setUnivType('Other') 
                //         // setIsOther(1);
                //   let val = newRecord['135'];
                //   if(val && val != ''){
                //     // setNewRecord((prevState) => ({
                //     //   ...prevState,
                //     //   "university_board_other" : val,
                //     //   // '135' : { value: "Other", label: "Other" }
                //     // }));
                //   // }
                // }else{
                //     // setUnivType('');
                //     // setIsOther(0);
                //   }
                // } 
                // if(value?.id == 135){
                //   if(value?.field_value == 'Other'){
                //     setUnivType((prev) => ({
                //       ...prev,
                //       [index] : 'Other'
                //     }))
                //   }else{
                //     setUnivType((prev) => ({
                //       ...prev,
                //       [index] : ''
                //     }))
                //   }
                // }               
  
              // if (value.id == 52) {
              //   setChecked(value.field_value == 1 ? true : false);
              // }
  
              // if(value.id == 465 && value.field_value != '' && value?.field_value != null){
              //   debugger
              //   // if(allFieldsFlag){
              //     setNewRecord((prevState) => ({
              //       ...prevState,
              //       [value.id]: {label: value.field_value, value: value.field_value},
              //     }));
  
              //   // }else{
              //   //   setNewRecord((prevState) => ({
              //   //     ...prevState,
              //   //     [value.id]: {},
              //   //   }));
              //   // }
                  
              //   }else{
  
                
                  // setNewRecord((prevState) => ({
                  //   ...prevState,
                  //   [value.id]: value.field_value,
                  // }));
                // }
                
  
              // setNewRecord((prevState) => ({
              //       ...prevState,
              //       [value.id]: value.field_value,
              //     }));
  
              // if(value.id == 135 && value.field_value != ''){
              //   // setIsDisabled(false);
              //   setNewRecord((prevState) => ({
              //           ...prevState,
              //           464 : '',
              //         }));
              // }
              
            }
          );


        })
      // }
      if(allCompleted && education?.transation_id && education?.transation_id != '' ){
        setAllDisabled(true)
        localStorage.setItem("disableEditDigi", true);
      }else{ 
        setAllDisabled(false);
      } 
    }


  },[education])

  const universitySelectHandler = (value, valueList, index, orgID) => {
    // let listType
    let checkbox = document.getElementsByClassName("digilockerDoc-checkbox");
    for (let i = 0; i < checkbox.length; i++) {
      checkbox[i].checked = false;
    }
    var cols = document.getElementById(value[0].err_id);
    if(cols)
    cols.innerHTML = "";
    //this is state is for the purpose of storing data to the api
    if (value[0].fieldname == "university_board") {
      setNewRecord(prevRecord => ({
        ...prevRecord, // Spread the previous state to maintain other top-level properties
        [index]: {
          ...prevRecord[index], // Spread the existing properties of the object at key 2
          // "62": newValue, // Set the new value for key 62
          [value[0].fieldId]: value[0].value.name,
          465: {},
          464: {},
        }
      }));
      // setNewRecord((prevState) => ({
      //   ...prevState,
      //   [value[0].fieldId]: value[0].value.name,
      //   465: {},
      // }));
      //this is state is for the purpose of storing data to the api

      //this is state is for validation purpose
      setNewValidationRecord((prevState) => ({
        ...prevState,
        [value[0].name]: value[0].value.name,
      }));
      setAllFields([]);
      setAllFieldsResponse({});
      setAllResponseError({});
    }
    if (value[0].fieldname == "document_type") {
      setAllFields([]);
      setAllFieldsResponse({});
      setAllResponseError({});
      setNewRecord((prevState) => ({
        ...prevState,
        [value[0].fieldId]: {
          label: value[0].value.label,
          value: value[0].value.value,
        },
      }));
      //this is state is for the purpose of storing data to the api

      //this is state is for validation purpose
      setNewValidationRecord((prevState) => ({
        ...prevState,
        [value[0].name]: value[0].value.label,
      }));
    }

    //this is state is for validation purpose
    if (
      value[0].fieldname == "university_board" &&
      value[0].value.name == "Other"
    ) {
      updateEduDetails(
        value[0]?.checkdetailsindex,
        value[0]?.fieldname,
        value[0]?.fieldname == "university_board"
          ? value[0]?.value.name
          : value[0]?.fieldname == "document_type"
          ? { label: value[0].value.label, value: value[0].value.value }
          : value[0]?.value.label
      );
    }
    if (value[0].fieldname == "university_board") {
      // setIsDisabled(false);
      setAllFields([]);
      setAllFieldsResponse([]);
      console.log(newRecord);
      if (value[0].value.name == "Other") {
        setUnivType((prev) => ({
          ...prev,
          [index]: "Other", 
        }))      
        setIsOther(1);
        setShowAllFields(false);
        // localStorage.setItem('isDigilocker',JSON.stringify(1));
      } else {
        setShowAllFields(true);
        // setUnivType("");
        setUnivType((prev) => ({
          ...prev,
          [index]: "", 
        }))  
        setIsOther(0);
        // localStorage.setItem('isDigilocker',JSON.stringify(1));
        dispatch(getDigiMoqList(value[0].value?.value?.id, index, callbackMoq));
        // setIsLoading(true);
      }
    }

    if (value[0].fieldname == "document_type") {
      // dispatch(
      //   getDigiLockerFields(value[0].value.value.doc_type_id, callbackFields)
      // );
      setAllFields([]);
      dispatch(
        getDigiLockerFields(
          value[0].valueList,
          value[0].value.value.master_org_id,
          callbackFields
        )
      );
      setIsLoading(true);
    }

    // updateEduDetails(
    //   value[0].checkdetailsindex,
    //   'digilocker_data',
    //   ''
    // );
    // updateEduDetails(
    //   value[0].checkdetailsindex,
    //   'document_type',
    //   ''
    // )
    // updateEduDetails(
    //   value[0].checkdetailsindex,
    //   value[0].fieldname,
    //   value[0].value
    // );
    updateUnivEduDetails(value[0].checkdetailsindex, value[0].fieldname, value[0].value, orgID)
  };

  const selectHandler = (value, index) => {
    console.log("fr", value);
    if (value[0].fieldname == "extra_remarks") {
      //console.log("true");
      if (value[0].value.trim() == "") {
        value[0].value = "";
      }
    }
    // alert(JSON.stringify(value))
    var cols = document.getElementById(value[0].err_id);
    cols.innerHTML = "";
    //this is state is for the purpose of storing data to the api
    setNewRecord(prevRecord => ({
      ...prevRecord, // Spread the previous state to maintain other top-level properties
      [index]: {
        ...prevRecord[index], // Spread the existing properties of the object at key 2
        [value[0].fieldId]: value[0].value,
      }
    }));
    // setNewRecord((prevState) => ({
    //   ...prevState,
    //   [value[0].fieldId]: value[0].value,
    // }));
    console.log(newRecord);
    //this is state is for the purpose of storing data to the api

    //this is state is for validation purpose
    setNewValidationRecord((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));
    //this is state is for validation purpose

    //alert(JSON.stringify(value));
    updateEduDetails(
      value[0].checkdetailsindex,
      value[0].fieldname,
      value[0].value
    );
    // updateEduDetails(value[0].checkdetailsindex, value[0].fieldname, value[0].value)
  };

  const callbackMoq = (data, res, index) => {
    setIsDisabled(false);
    console.log(res);

    // setMoqOptions(res)

    // setMoqOptions(data);
    setMoqOptions((prev) => ({
      ...prev,
      [index] : data
    }))
    setIsLoading(false);
  };

  const callbackFields = (data, isAddMore) => {
    setAllFields(data);
    isAddMore ? setAddMore(true) : setAddMore(false);
    data.map((key) => {
      let label = key.paramname;
      setAllFieldsResponse((prev) => ({
        ...prev,
        [label]: "",
      }));
      setAllResponseError((prev) => ({
        ...prev,
        [label]: "",
      }));
    });
    setIsLoading(false);
  };

  const updateEduDetails = (dataset, name, value) => {
    // alert(value);
    let eduDetails = _.cloneDeep(education);
    console.log(eduDetails);
    console.log(eduDetails.checksDetails[dataset]);
    if (eduDetails && eduDetails.checksDetails[parseInt(dataset)])
      eduDetails.checksDetails[parseInt(dataset)].fields[name].field_value =
        value;
    console.log("ee", eduDetails);
    setEducation(eduDetails);
    // console.log("ee", education);
  };

  const updateUnivEduDetails = (dataset, name, value, orgID) => {
    // alert(value);
    let eduDetails = _.cloneDeep(education);
    console.log(eduDetails);
    console.log(eduDetails.checksDetails[dataset]);
    if (eduDetails && eduDetails.checksDetails[parseInt(dataset)]){
      
      eduDetails.checksDetails[parseInt(dataset)].fields[name].field_value = value;
      
      // clearing digiLocker data from education 

      eduDetails.checksDetails[parseInt(dataset)].fields['digilocker_data'].field_value = "";

      // clearing docType data from education

      eduDetails.checksDetails[parseInt(dataset)].fields['document_type'].field_value = "";
      // commented for IB-19559 Digilocker dependent fields gets removed bug fix.
      if(orgID){
        eduDetails.checksDetails[parseInt(dataset)].edu_org_id = orgID;
      }

    }
    console.log("ee", eduDetails);
    setEducation(eduDetails);
  };

  const selectHandler2 = (value) => {
    
    const ob={...otherInstituteObj};
    if(!value){
      setOtherInstituteObj({})
      setFormVal({})
      return
    }
    ob.isVisible=false;
    if(value[0].value=='other'){
      ob.isVisible=true;
      setOtherInstituteObj((prev) => ({
        ...prev,
        [value[0].checkdetailsindex] : {value:'',isError:false,isVisible:true}
      }))
    }else{
      // ob.value = ''
      setOtherInstituteObj((prev) => ({
        ...prev,
        [value[0].checkdetailsindex] : {value:'',isError:false,isVisible:false}
      }))
    }
    // setOtherInstituteObj(ob);
    var cols = document.getElementById(value[0].err_id);
    cols.innerHTML = "";
    setFormVal((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));
  };

  const updateOtherInstitute = (value) => {
    const custumUniversityName=value[0].value;
    const ob={...otherInstituteObj};
    ob.value=custumUniversityName;
    if(value[0].value != ''){
      ob.isError = false;
    }
    setOtherInstituteObj((prev) => ({
      ...prev,
      [value[0].index] : {value: custumUniversityName ,isError:false,isVisible:true}
    }))
    // setOtherInstituteObj(ob);
    // var cols = document.getElementById(value[0].err_id);
    // cols.innerHTML = "";
    setFormVal((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));
  };

  //for getting the info of fields taht is formatted as per the api format
  const textHandler = (value,index) => {
    console.log("fr", value);
    if (
      value[0].fieldname == "roll_no" ||
      value[0].fieldname == "grade_percentage" ||
      value[0].fieldname == "university_board_other"
    ) {
      //console.log("true");
      if (value[0].value.trim() == "") {
        value[0].value = "";
      }
    }
    var cols = document.getElementById(value[0].err_id);
    cols.innerHTML = "";
    //this is state is for the purpose of storing data to the api
    if (value[0].fieldname == "university_board_other") {
      setNewRecord(prevRecord => ({
        ...prevRecord, // Spread the previous state to maintain other top-level properties
        [index]: {
          ...prevRecord[index], // Spread the existing properties of the object at key 2
          [value[0].fieldId]: value[0].value,
          university_board_other: value[0].value,        
        }
      }));
      // setNewRecord((prevState) => ({
      //   ...prevState,
      //   [value[0].fieldId]: value[0].value,
      //   university_board_other: value[0].value,
      //   // 1
      // }));
      // }
    } else {
      setNewRecord(prevRecord => ({
        ...prevRecord, // Spread the previous state to maintain other top-level properties
        [index]: {
          ...prevRecord[index], // Spread the existing properties of the object at key 2
          [value[0].fieldId]: value[0].value,
        }
      }));
      // setNewRecord((prevState) => ({
      //   ...prevState,
      //   [value[0].fieldId]: value[0].value,
      // }));
    }

    //this is state is for the purpose of storing data to the api

    //this is state is for validation purpose
    setNewValidationRecord((prevState) => ({
      ...prevState,
      [value[0].name]: value[0].value,
    }));
    //this is state is for validation purpose

    //alert(JSON.stringify(value));
    // if(value[0].fieldname !=  'university_board_other')
    // updateEduDetails(
    //   value[0].checkdetailsindex,
    //   value[0].fieldname == 'university_board_other' ?
    //   "university_board_other" :
    //   value[0].fieldname,
    //   value[0].value
    // );

    updateEduDetails(
      value[0].checkdetailsindex,
      value[0].fieldname,
      value[0].value,
      value[0]?.collegeOther
    );
    if(value[0]?.collegeOther){
      const custumUniversityName = value[0]?.collegeOther;
        const ob={...otherInstituteObj};
        ob.value = value[0]?.collegeOther;
        setOtherInstituteObj((prev) => ({
        ...prev,
        [index] : {value: custumUniversityName , isError:false, isVisible:true}
       }))
    }
  };

  const handleTabClick = (index, uploadFlag) => {

    // return if current tab is not submited
    if(index == activeTab){
      return;
    }
    
    let flag = localStorage.getItem("disableEditDigi");
    flag == 'true' && education?.transation_id && education?.transation_id != "" ? setAllDisabled(true) : setAllDisabled(false);

    let url = window.location.href.split('/');
    if(index < activeTab){
      setActiveTab(index);
      if(url.length> 0 && url[url.length - 1] == 'uploadDigi'){
        url.pop();
        // navigate(url.join('/'))
      navigate(`/case-initiation/check-detail/${reference}/3`)

      }
      return;
    }

    if(education && (education.checksDetails[activeTab - 1]?.check_status == 2 || education.checksDetails[activeTab - 1]?.check_status == 3)){
    let flag = localStorage.getItem("digiResponse");
    if(uploadFlag){
        let allCheckSumbitted = true;
        education && Object.values(education.checksDetails).map((data,index) => {
          if(data?.check_status == 1 ){
            allCheckSumbitted = false;
          }
        })
        if(allCheckSumbitted){
          setActiveTab(index);
          navigate('./uploadDigi');
        }else{
          let err = 'Please save all education forms'
          toast.error(err, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
      }else{
        if(education.checksDetails[index - 2]?.check_status == 2 || education.checksDetails[index - 2]?.check_status == 3){
          setActiveTab(index);
          // navigate('./uploadDigi');
          if(url.length> 0 && url[url.length - 1] == 'uploadDigi'){
            url.pop();
            // navigate(url.join('/'))
            navigate(`/case-initiation/check-detail/${reference}/3`)
          }
        }else{
          let err = 'Please save previous education forms first.'
          toast.error(err, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });

        }

      }
    
    }else{
      let err = 'Please save current education form'
          toast.error(err, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
    }
  

    // if(uploadFlag){
    //   // logic to check all tabs completed status
    // }

    // setActiveTab(index);

    if(tabsFieldData[index-1]?.university_board?.field_value == "Other" || tabsFieldData[index-1]?.university_board?.field_value == ""){
      setShowAllFields(false);
    }else{
      setShowAllFields(true);
    }
  };

  const formValidation = (caseCheckId, activeTabIndex, otherFlag,isadd) => {
    const errors = {};
    let isError = false;

    // resetting all errors first
    // var cols = document.getElementsByClassName("err text-danger");
    // for (let i = 0; i < cols.length; i++) {
    //   cols[i].innerHTML = "";
    // }

    // let activeTab = activeTab - 1;
    let case_check_id = education.checksDetails[activeTab - 1].case_check_id;

    let field_qualification_degree =
      education.checksDetails[activeTab - 1].fields.qualification_degree;
    //checking if filed coming from api is mandatory
    if (field_qualification_degree.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_qualification_degree.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId + "_" + activeTabIndex;
      let elementName = "qualificationDegree_" + case_check_id;
      let value_element = document
        .getElementsByName("qualificationDegree_" + case_check_id + "_" + "value")
        [0]
        .value.trim();

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        if(document?.getElementById(elementErrorId)){
          document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
          isError = true;
        }
      }
    }

    let field_course_name =
      education.checksDetails[activeTab - 1].fields.course_name;
    //checking if filed coming from api is mandatory
    if (field_course_name.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_course_name.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId + "_" + activeTabIndex;
      let elementName = "courseName_" + case_check_id;
      let value_element;
      if (education.course_auto_suggest) {
        value_element = document
          .getElementById("courseName_" + case_check_id)
          ?.value?.trim();
      } else {
        value_element = document
          .getElementById("courseName_" + case_check_id)
          ?.innerText?.trim();
      }
      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        if(document?.getElementById(elementErrorId)){
          document.getElementById(elementErrorId).innerHTML =
            "This field is required.";
          isError = true;
        }
      }
      // }
    }

    let field_university_board =
      education.checksDetails[activeTab - 1].fields.university_board;
    //checking if filed coming from api is mandatory
    if (field_university_board.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_university_board.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId + "_" + activeTabIndex;
      let elementName = "universityBoard_" + case_check_id;
      let value_element = document
        .getElementById("universityBoard_" + case_check_id)
        .value.trim();

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }    

    let field_grade_percentage =
    education.checksDetails[activeTab - 1].fields.grade_percentage;
  // checking if filed coming from api is mandatory
  if (field_grade_percentage.is_mandatory == 1) {
    //getting field id from api data
    let fieldId = field_grade_percentage.id;
    //identifying which err id element needs to be populated with error
    let elementErrorId = "err_" + case_check_id + "_" + fieldId + "_" + activeTabIndex;
    let elementName = "grade_" + case_check_id;
    let value_element = document
      .getElementById("grade_" + case_check_id)
      .value.trim();

    if (
      value_element === undefined ||
      value_element === null ||
      value_element === ""
    ) {
      document.getElementById(elementErrorId).innerHTML =
        "This field is required.";
      isError = true;
    }
  }

    let field_roll_no =
    education.checksDetails[activeTab - 1].fields.roll_no;
  // checking if filed coming from api is mandatory
  if (field_roll_no.is_mandatory == 1) {
    //getting field id from api data
    let fieldId = field_roll_no.id;
    //identifying which err id element needs to be populated with error
    let elementErrorId = "err_" + case_check_id + "_" + fieldId + "_" + activeTabIndex;
    let elementName = "rollNo_" + case_check_id;
    let value_element = document
      .getElementById("rollNo_" + case_check_id)
      .value.trim();

    if (
      value_element === undefined ||
      value_element === null ||
      value_element === ""
    ) {
      if(document?.getElementById(elementErrorId)){
      document.getElementById(elementErrorId).innerHTML =
        "This field is required.";
      isError = true;
      }
    }
  }
      if (univType[activeTabIndex] == "Other" || otherFlag == 'Other') {
        // removing the other university field

      // let field_university_board_other =
      // education.checksDetails[activeTab - 1].fields.university_board_other;
      // if(field_university_board_other.is_mandatory == 1){
      // let elementErrorId = "err_" + case_check_id + "_university_board_other" + "_" + activeTabIndex;
      // let elementName = "universityBoardOther_" + case_check_id;
      // let value_elementother = document
      //   .getElementById("universityBoardOther_" + case_check_id)
      //   .value.trim();

      // if (
      //   value_elementother === undefined ||
      //   value_elementother === null ||
      //   value_elementother === ""
      // ) {
      //   document.getElementById(elementErrorId).innerHTML =
      //     "This field is required.";
      //   isError = true;
      // }
      // }
    }
    // if (univType[activeTabIndex] != "Other" && univType[activeTabIndex] != "") {
    //   let field_document_type =
    //     education.checksDetails[activeTab - 1].fields.document_type;
    //   let fieldId = field_document_type.id;

    //   if (field_document_type.is_mandatory == 1) {
    //     let elementErrorId = "err_" + case_check_id + "_" + fieldId + "_" + activeTabIndex;
    //     let elementName = "docType_" + case_check_id;
    //     let value_element = document.getElementById(
    //       "docType_" + case_check_id + "_value"
    //     ).value;

    //     if (
    //       value_element === undefined ||
    //       value_element === null ||
    //       value_element === ""
    //     ) {
    //       document.getElementById(elementErrorId).innerHTML =
    //         "This field is required.";
    //       isError = true;
    //     }
    //     // if (allFields.length == 0) {
    //     //   document.getElementById(elementErrorId).innerHTML =
    //     //     "This field is required.";
    //     //   isError = true;
    //     // }
    //   }

    //   // allFields &&
    //   //   allFields.length > 0 &&
    //   //   Object.entries(allFieldsResponse).map(([key, value]) => {
    //   //     // console.log(key + '' + value);
    //   //     if (value.trim() == "") {
    //   //       setAllResponseError((prev) => ({
    //   //         ...prev,
    //   //         [key]: "This field is required",
    //   //       }));
    //   //       let elementErrorId = key;
    //   //       let value = document.getElementById(elementErrorId);
    //   //       document.getElementById(elementErrorId).innerHTML =
    //   //         "This field is required.";
    //   //       isError = true;
    //   //     }
    //   //   });
    // }

    const cisSlug = "verificationName_" + caseCheckId;
    let field_cis = education.checksDetails[activeTab - 1].fields[cisSlug];

    // let field_qualification_degree = education.checksDetails[activeTab].fields.qualification_degree;

    //checking if filed coming from api is mandatory
    if (field_cis?.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_cis.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId + "_" + activeTabIndex;
      let elementName = "cis_" + case_check_id;

      // let value_element = document.getElementsByName('cis_' + case_check_id + "_value")[0].value.trim();
      let value_elements = document
        .getElementById("cis_" + case_check_id)
        .value.trim();
      console.log("fr", value_elements);

      if (
        value_elements === undefined ||
        value_elements === null ||
        value_elements === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    let field_mode_of_qualification =
      education.checksDetails[activeTab - 1].fields.mode_of_qualification;
    //checking if filed coming from api is mandatory
    if (field_mode_of_qualification.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_mode_of_qualification.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId + "_" + activeTabIndex;
      let elementName = "modeOfQualification_" + case_check_id;
      let value_element = document.getElementById(
        "modeOfQualification_" + case_check_id + "_value"
      ).value;

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        if(document?.getElementById(elementErrorId)){
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
        }
      }
    }
    // Other flow validations
    // if (univType[activeTabIndex] == "Other") {
    // }
    
    let field_college_location =
      education.checksDetails[activeTab - 1].fields.college_location;
    // checking if filed coming from api is mandatory
    if (field_college_location.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_college_location.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId + "_" + activeTabIndex;
      let elementName = "location_" + case_check_id;
      let value_element = document
        .getElementById("location_" + case_check_id)
        .value.trim();

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }
    let field_batch_start_year =
      education.checksDetails[activeTab - 1].fields.batch_start_year;
    //checking if filed coming from api is mandatory
    if (field_batch_start_year.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_batch_start_year.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId + "_" + activeTabIndex;
      let elementName = "batchStart_" + case_check_id;
      let value_element = document.getElementById(
        "batchStart_" + case_check_id
      ).value;

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }

    let field_batch_end_year =
      education.checksDetails[activeTab - 1].fields.end_year;
    //checking if filed coming from api is mandatory
    if (field_batch_end_year.is_mandatory == 1) {
      //getting field id from api data
      let fieldId = field_batch_end_year.id;
      //identifying which err id element needs to be populated with error
      let elementErrorId = "err_" + case_check_id + "_" + fieldId + "_" + activeTabIndex;
      let elementName = "batchEnd_" + case_check_id;
      let value_element = document.getElementById(
        "batchEnd_" + case_check_id
      ).value;

      if (
        value_element === undefined ||
        value_element === null ||
        value_element === ""
      ) {
        document.getElementById(elementErrorId).innerHTML =
          "This field is required.";
        isError = true;
      }
    }
    
    return isError;
  };

  //form save handler

  const saveHandler = (event, caseCheckId, activetabIndex,isadd, digiPayload, orgid, digiErr, otherFlag, flag) => {
    // console.log(allResponseError)
     event.preventDefault();
    // const formData2 = {};
    // formData2.formVal1 = formVal.formVal1;
    console.log(caseCheckId);
    const err = formValidation(caseCheckId, activetabIndex, otherFlag,isadd);
    let otherInstituteErr = false;
    if(otherInstituteObj && otherInstituteObj?.[activetabIndex]){
      otherInstituteErr=otherInstituteObj?.[activetabIndex]?.isVisible && !otherInstituteObj?.[activetabIndex]?.value ? true : false;
    }
    // let err = false;
    // const isValidationPassed = Object.keys(err).length === 0;
    console.log(caseCheckId);
    if (err === true || digiErr === true  || otherInstituteErr == true) {
      if(isadd==1){
        toast.error(`Please fill the current form and click 'Add Education'`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
      if(otherInstituteErr){
        // const ob={...otherInstituteObj};
        // ob.isError=true;
        // setOtherInstituteObj(ob);
        setOtherInstituteObj((prev) => ({
          ...prev,
          [activetabIndex] : {value:'',isError:true,isVisible:true}
        }))
      }
      setFormError(err);
      window.scroll({ top: 0, left: 0, behavior: "smooth" });
    } else {
      let verificationSource = document.getElementById(
        "cis_" + caseCheckId + "_value"
      ).value;
      let test = document.getElementById(
        "cis_" + caseCheckId
      );
      let verificationSourceText = document.getElementById(
        "cis_" + caseCheckId
      ).value;

      const additonalData = {
        // "verificationCourse": "4",
        // verificationName: verificationSourceText,
        // verficationName: '0',
        // verificationSource: parseInt(verificationSource),
        verificationSourceText: verificationSourceText,
        // "otherVerificationSource": 
      };
      if(otherInstituteObj?.[activetabIndex]?.value){
        additonalData.verificationName = 1;
        additonalData.otherVerificationSource = otherInstituteObj?.[activetabIndex]?.value;
        additonalData.verificationSource = '';
      }else{
        additonalData.verificationName = 0;
        additonalData.verificationSource = parseInt(verificationSource);
      }

      const recordData = {};
      recordData.case_check_id = caseCheckId;

      let obj = {};
      if ((univType[activetabIndex] != "Other" && otherFlag != 'Other') && orgid) {
        // if (newRecord[465].label != "" && allFields.length > 0) {
          if(Object.keys(digiPayload).length > 0){
          // saveDigilockerPayload();
          obj = {
            group: "education",
            // "13": "12\/2014",
            // "69": "3",
            // "11": "3333",
            // "12": "",
            // "138": "test",
            // "52": "1",
            ...newRecord[activetabIndex],
            ...additonalData,
            ...digiPayload,
            // digiLockerFields: allFieldsResponse,
            466 : '',
            orgId:orgid,
            // orgId: allFields[0].org_id,
            is_other: univType[activetabIndex],
          };
        } else {
          setFormError(err);
          window.scroll({ top: 0, left: 0, behavior: "smooth" });
        }
      } else {
        obj = {
          group: "education",
          // "13": "12\/2014",
          // "69": "3",
          // "11": "3333",
          // "12": "",
          // "138": "test",
          // "52": "1",
          ...newRecord[activetabIndex],
          ...additonalData,
          // is_other: univType[activetabIndex],
          is_other: 1
        };
      }
      // debugger
      // recordData.check_data = { [caseCheckId]: { "group": "education", ...newRecord, ...additonalData } };
      // if(obj[135] == ""){
      let case_check_id = education.checksDetails[activeTab - 1].case_check_id;
      let value_element = document
        .getElementById("universityBoard_" + case_check_id)
        .value.trim();
        let test_element = document
        .getElementById("universityBoard_" + case_check_id);  
      if (value_element != "") {
        obj[135] = value_element;
      }
      // }
      console.log(obj);
      recordData.check_data = { [caseCheckId]: obj };
      console.log(obj);
      localStorage.setItem("recordData", JSON.stringify(recordData));
      
      dispatch(saveEducation(recordData, isadd, callbackforOtherInstitute));
      if(!isadd){
        setAdd(0);
      }
    }
  };

  const callbackforOtherInstitute=(is_add,data)=>{
    setOtherInstituteObj({value:'',isError:false,isVisible:false});
    if(is_add==1)
      { 
        dispatch(addEducation());
        setAdd(is_add)
        localStorage.setItem('disableEditDigi', false);
      }

  }

  const setMoqOptionsCallback = (data, idx) => {
    setMoqOptions((prev) => ({
      ...prev,
      [idx] : data
    }))
    // setUnivType((prev) => ({
    //   ...prev,
    //   [idx] : 
    // }))
  }


  const closeDigiPopup = () => {
    setShowDigiPopup(false);
  };

  const handleSaveData = (e) => {
    e.preventDefault();
    // let digilockerObject = JSON.parse(localStorage.getItem("digiObj"));
    // let finalData = {}
    // let convertedData = Object.values(digilockerObject);
    // let convertedData = data.map((obj, item) => {
    //   let key = Object.keys(item)[0];
    //   obj[key] = item;
    //   // finalData = {...obj};
    //   return obj;
    // }, {});
    // console.log(convertedData);
    // console.log(allFields);
    // if(Object.entries(convertedData).length > 0 ){
      setIsLoading(true);
      dispatch(verifyDigiLockerDocuments(getDigilockerUrl));
      
    // }else{
    // setShowDigiPopup(false);
    // }
  };
  

  const getDigilockerUrl = (url,trans_id) => {
    setShowDigiPopup(false);
    localStorage.setItem('digiTransId', JSON.stringify(trans_id));
    
    window.location.href = url;
  };

  const handleNewRecord = (record, index) => {
    setNewRecord((prev) => ({
      ...prev,
      [index] : record
    }))
  }



  console.log(univType, 'uni');
  console.log(newRecord, 'MultiRecord');
  console.log(otherInstituteObj, 'collegeOther');

  return (
    <>
    {showDigiPopup && (
        <DigilockerPopup
          showModalBox={1}
          closePopup={closeDigiPopup}
          // proceedHandler={proceedRemove}
          isAdd={false}
          handleSaveData={handleSaveData}
        />
      )} 
      {isLoading && <Loader />}
      {<div className="container-fluid">
        <div className="row p-0 m-0">
          <div className="col-auto p-0 m-0 w-100">
            <div className="navtab st-navtab">
              <ul
                className="nav st-nav-tabs nav-tabs btn-group border-0"
                role="group"
              >
                {tabs.map((tab, index) => (
                  <li
                    key={index}
                    className={`nav-item st-nav-item rounded-0 ${
                      index + 1 === activeTab ? "active" : ""
                    }`}
                  >
                    <span
                      className="nav-link st-nav-link rounded-0"
                      onClick={() => {
                        handleTabClick(index + 1);
                        setSelectedCaseCheckId(tab?.case_check_id);
                      }}
                      role="button"
                    >
                      {/* {tab.label} */}
                      {(tabs[index]?.check_status === 2 || tabs[index]?.check_status === 3) && (
                      <i class="fas fa-check-circle mr-1"></i>
                      )} 
                      {checkName} {index + 1}
                    </span>
                  </li>
                ))}
                <li
                  key={tabs.length + 1}
                  className={`nav-item st-nav-item rounded-0 ${
                    tabs.length + 1 === activeTab ? "active" : ""
                  }`}
                >
                  <span
                    className="nav-link st-nav-link rounded-0"
                    onClick={() => {
                      handleTabClick(tabs.length + 1, true);
                      setSelectedCaseCheckId(null);
                    }
                    }
                    role="button"
                  >
                    {/* {tab.label} */}
                    Upload Documents
                  </span>
                </li>
              </ul>

              {activeTab <= tabs.length ? (
                <div className="tab-content border-top my-4 pt-4">
                  {Object.values(tabsFieldData)?.map((tab, index) => {
                    let caseChId,
                      docVis,
                      slug,
                      showVal,
                      verficationSourceName,
                      verficationSourceid;
                    if (tab && tabs) {
                      caseChId = tabs[index]?.case_check_id;
                      docVis = tabs[index]?.document_visibility;
                      slug = "verificationName_" + tabs[index]?.case_check_id;
                      verficationSourceName = tabs[index]?.verification_source_name;
                      verficationSourceid = tabs[index]?.verification_source_id;
                      // console.log("index = ", index);
                      if(tabsFieldData[index]?.fields?.university_board?.field_value == "Other" || tabsFieldData[index]?.fields?.university_board?.field_value == "" ){
                        showVal = false
                        // setShowAllFields(false);
                      }else{
                        showVal = true;
                        // setShowAllFields(true);
                      }
                    }
                    console.log('digiTab' , tabsFieldData)
                    return (
                      <div
                        key={`tab-${index}`}
                        className={`tab-pane ${
                          index + 1 === activeTab ? "active" : ""
                        }`}
                      >
                        {/* {tabsFieldData} */}
                        <DigiTab
                          fieldData={tabsFieldData[index]}
                          setActiveTab={setActiveTab}
                          activeTab={activeTab}
                          digiLockerUniversityList={digiLockerUniversityList}
                          modeOfQualificationOptions={
                            modeOfQualificationOptions
                          }
                          qualificationOptions={qualificationOptions}
                          veridficationCourseNameOptions={
                            veridficationCourseNameOptions
                          }
                          caseCheckId={caseChId}
                          cisSlug={slug}
                          documentVisibility={docVis}
                          moqOptions={moqOptions[index]}
                          universitySelectHandler={universitySelectHandler}
                          showAllDigiFields={showAllFields}
                          selectHandler={selectHandler}
                          index={index}
                          verficationSourceName={verficationSourceName}
                          verficationSourceid={verficationSourceid}
                          selectHandler2={selectHandler2}
                          updateOtherInstitute={updateOtherInstitute}
                          otherInstituteObj={otherInstituteObj}
                          setOtherInstituteObj={setOtherInstituteObj}
                          univTypeProp={univType[index]}
                          key={`education-${index}`}
                          education={education}
                          textHandlerMulti={textHandler}
                          saveHandler={saveHandler}
                          newRecord={newRecord[index]}
                          showVal={showVal}
                          setMoqOptionsCallback={setMoqOptionsCallback}
                          allDisabled={allDisabled}
                          handleNewRecord={handleNewRecord}
                          // allFields={allFields}
                          // addMore={addMore}
                        />
                      </div>
                    );
                  })}
                </div>
              ) : (
                <>
                  <UploadDIgiDocs />
                </>
              )}
            </div>
          </div>
        </div>
      </div>}
    </>
  );
};

export default MultiTabEdu;
